/***
 * @file: é»è®¤ä¸»é¢
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Component, Inject, OnDestroy } from '@angular/core';
import { findIndex } from 'lodash';
import { fromEvent, Subscription } from 'rxjs';

import { ScrollService, SettingsNotify, SettingsService } from '@ithinkdt/shared/browser';
import { I18NService } from '@ithinkdt/shared/i18n';
import { UrlChangeService } from '@ithinkdt/shared/route';
import { COMMON_COMFIG, WINDOW } from '@ithinkdt/shared/utils';
import { PageData, Pages, ThemeConfig } from '@ithinkdt/theme/models';
import { PageTabService } from '@ithinkdt/theme/page-tab-service';
import {
  COLLAPSED_KEY,
  CONTENT_WIDTH_KEY,
  FIX_HEADER_KEY,
  HIDE_HEADER_KEY,
  NAV_MODE_KEY,
} from '@ithinkdt/theme/setting-drawer';

// è®¾å®scrollå¤è¿æä¼éèheader
const DEFAULT_POSI = 110;
@Component({
  selector: 'dt-ant-design-theme',
  templateUrl: './ant-design-theme.component.html',
  styleUrls: ['./ant-design-theme.component.scss'],
})
export class IthinkdtThemeComponent implements OnDestroy {
  themeConfig: ThemeConfig;
  /** æå¼çé¡µé¢ */
  pages: Pages;
  /** æ¶èçé¡µé¢ */
  collection: PageData[];
  /** æ¯å¦å±å¼ */
  collapsed = false;
  /** æ¯å¦ä¸ºé¡¶é¨èå */
  topMenu = false;
  /** åå®¹åºåæ¯å¦å®å®½ */
  fixWidth = false;
  /** æ¯å¦åºå®header */
  fixHeader = false;
  /** æ¯å¦ä¸æ»éèheader */
  hideHeader = false;
  /** ä¸æ»æ¶æ¯å¦åºè¯¥éè headerï¼ä¸æ»å°ä¸å®è·ç¦»æä¼éèï¼ */
  shouldHide = false;
  /** æ»å¨çä½ç½® */
  scrollPosi: number;
  // åºé¨æ¯å¦ææè¿°ï¼æè¿°ææ¡
  // footerDesc: string;

  private set$: Subscription;
  private url$: Subscription;
  private afterRouter$: Subscription;
  private scroll$: Subscription;
  private closeAllTabSub$: Subscription;

  constructor(
    private settings: SettingsService,
    private urlChange: UrlChangeService,
    private ScrollSrv: ScrollService,
    private pageTabSrv: PageTabService,
    private i18nSrv: I18NService,
    @Inject(WINDOW) private win: any
  ) {
    this.themeConfig = this.settings.userConfig['theme'] || {};
    this.addSettingSub();
    this.addUrlChangeSub();
    this.getStoredData();
    this.addCloseAllTabSub();
    const i18n = this.i18nSrv;
    // console.log('è¿å¥æ¶é´');
  }

  ngOnDestroy(): void {
    this.set$.unsubscribe();
    this.url$.unsubscribe();
    this.closeAllTabSub$.unsubscribe();
    this.removeScrollSub();
  }

  // è®¾ç½®éç½®ååçå¬
  addSettingSub() {
    this.set$ = this.settings.notify.subscribe((data: SettingsNotify) => {
      const { type, name, value } = data;
      switch (type) {
        // å¸å±æ¨¡å
        case 'layout':
          switch (name) {
            case COLLAPSED_KEY:
              this.collapsed = value;
              break;
            case NAV_MODE_KEY:
              this.topMenu = value;
              break;
            case FIX_HEADER_KEY:
              this.fixHeader = value;
              break;
            case HIDE_HEADER_KEY:
              this.hideHeader = value;
              value ? this.addScrollSub() : this.removeScrollSub();
              break;
            case CONTENT_WIDTH_KEY:
              this.fixWidth = value;
              break;
          }
        default:
          break;
      }
    });
  }

  addScrollSub() {
    this.scroll$ = fromEvent(this.win, 'scroll').subscribe((e) => {
      const posi = this.ScrollSrv.getScrollPosition()[1];
      if (posi > this.scrollPosi) {
        if (posi > DEFAULT_POSI) {
          this.shouldHide = true;
        }
      } else {
        this.shouldHide = false;
      }
      this.scrollPosi = posi;
    });
  }

  // çå¬urlæ¹å
  addUrlChangeSub() {
    this.url$ = this.urlChange.beforeUrl$.subscribe((data: PageData) => {
      this.handleUrlData(data);
    });
    // é¦æ¬¡è¿å¥è·¯ç±ä¹ååè¯»åä¸æ¬¡è·¯ç±ä¿¡æ¯ï¼åå»ºhome tabåæ¢æé®,
    // å ä¸ºå¨ç»å½ä¹åè¿å¥é¦é¡µä¹åè¯¥ç»ä»¶ä¸ä¼è¢«å®ä¾åï¼æä»¥`beforeUrl$`ä¸ä¼æ¨éåºæ¥æ°æ®ï¼
    // homeçtabåæ¢ä¸ä¼è¢«åå»º
    this.afterRouter$ = this.urlChange.urlChange$.subscribe((data: PageData) => {
      this.handleUrlData(data);
      this.afterRouter$.unsubscribe();
    });
  }

  // çå¬å³é­å¨é¨tab
  addCloseAllTabSub() {
    this.closeAllTabSub$ = this.pageTabSrv.closeAllTab$.subscribe((res) => {
      this.resetPage();
      this.settings.resetSettings();
    });
  }

  /**
   * @param data object
   * @desc å¤çurlä¸­çåæ°
   *   1. å¤æ­å½åè·¯ç±ä¿¡æ¯æ¯å¦å·²å­å¨å°æ°ç»
   *   2. å·²å­å¨åç´æ¥è·åä¸æ index
   *   3. æªå­å¨åå¡è¿æ°ç»
   */
  handleUrlData(data: PageData) {
    if (data.pureRouter === COMMON_COMFIG.LOGIN_URL) {
      this.getStoredData();
      return;
    }

    // å¦ææ¯ç¸åé¡µé¢åªæ¯è·¯ç±åæ°ä¸åï¼åå¨æ­¤é¡µé¢æåæ°å·æ°ï¼
    this.pages.data.forEach((page: PageData) => {
      if (page.pureRouter === data.pureRouter && page.url !== data.url) {
        page.url = data.url;
      }
    });

    const index = findIndex(this.pages.data, data);
    if (index > -1) {
      this.pages.index = index;
    } else {
      this.pages.data.push(data);
      this.pages.index = this.pages.data.length - 1;
    }
    this.settings.setPages(this.pages);
  }

  // tabåæ¢åååè°
  getTabChanges(data) {
    this.pages = data;
    this.settings.setPages(data);
  }

  // æ¶èåååè°
  getColChanges(data) {
    this.collection = data;
    this.settings.setCollection(data);
  }

  getStoredData() {
    this.pages = this.settings.pages;
    this.collection = this.settings.collection;
    this.collapsed = this.cachedData(COLLAPSED_KEY);
    this.topMenu = this.cachedData(NAV_MODE_KEY);
    this.fixWidth = this.cachedData(CONTENT_WIDTH_KEY);
    this.fixHeader = this.cachedData(FIX_HEADER_KEY);
    this.hideHeader = this.cachedData(HIDE_HEADER_KEY);
    if (this.hideHeader) {
      this.addScrollSub();
    }
  }

  removeScrollSub() {
    if (this.scroll$) {
      this.scroll$.unsubscribe();
    }
    this.shouldHide = false;
  }

  private cachedData(type) {
    return this.settings.layout[type];
  }

  resetPage() {
    this.pages = {};
    /** æ¶èçé¡µé¢ */
    this.collection = [];
  }
}
